'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var walletAdapterBase = require('@solana/wallet-adapter-base');
var web3_js = require('@solana/web3.js');
var walletStandardFeatures = require('@solana/wallet-standard-features');
var walletStandardMobile = require('@solana-mobile/wallet-standard-mobile');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

(undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
(undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

/** Name of the feature. */
const StandardConnect = 'standard:connect';

/** Name of the feature. */
const StandardDisconnect = 'standard:disconnect';

/** Name of the feature. */
const StandardEvents = 'standard:events';

(undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
(undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

(undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
(undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

function fromUint8Array(byteArray) {
    return window.btoa(String.fromCharCode.call(null, ...byteArray));
}

function getIsSupported() {
    return (typeof window !== 'undefined' &&
        window.isSecureContext &&
        typeof document !== 'undefined' &&
        /android/i.test(navigator.userAgent));
}

var _BaseSolanaMobileWalletAdapter_instances, _BaseSolanaMobileWalletAdapter_wallet, _BaseSolanaMobileWalletAdapter_connecting, _BaseSolanaMobileWalletAdapter_readyState, _BaseSolanaMobileWalletAdapter_accountSelector, _BaseSolanaMobileWalletAdapter_selectedAccount, _BaseSolanaMobileWalletAdapter_publicKey, _BaseSolanaMobileWalletAdapter_handleChangeEvent, _BaseSolanaMobileWalletAdapter_connect, _BaseSolanaMobileWalletAdapter_declareWalletAsInstalled, _BaseSolanaMobileWalletAdapter_assertIsAuthorized, _BaseSolanaMobileWalletAdapter_performSignTransactions, _BaseSolanaMobileWalletAdapter_runWithGuard;
const SolanaMobileWalletAdapterWalletName = 'Mobile Wallet Adapter';
const SIGNATURE_LENGTH_IN_BYTES = 64;
function isVersionedTransaction(transaction) {
    return 'version' in transaction;
}
function chainOrClusterToChainId(chain) {
    switch (chain) {
        case 'mainnet-beta':
            return 'solana:mainnet';
        case 'testnet':
            return 'solana:testnet';
        case 'devnet':
            return 'solana:devnet';
        default:
            return chain;
    }
}
class BaseSolanaMobileWalletAdapter extends walletAdapterBase.BaseSignInMessageSignerWalletAdapter {
    constructor(wallet, config) {
        super();
        _BaseSolanaMobileWalletAdapter_instances.add(this);
        this.supportedTransactionVersions = new Set(
        // FIXME(#244): We can't actually know what versions are supported until we know which wallet we're talking to.
        ['legacy', 0]);
        _BaseSolanaMobileWalletAdapter_wallet.set(this, void 0);
        _BaseSolanaMobileWalletAdapter_connecting.set(this, false);
        _BaseSolanaMobileWalletAdapter_readyState.set(this, getIsSupported() ? walletAdapterBase.WalletReadyState.Loadable : walletAdapterBase.WalletReadyState.Unsupported);
        _BaseSolanaMobileWalletAdapter_accountSelector.set(this, void 0);
        _BaseSolanaMobileWalletAdapter_selectedAccount.set(this, void 0);
        _BaseSolanaMobileWalletAdapter_publicKey.set(this, void 0);
        _BaseSolanaMobileWalletAdapter_handleChangeEvent.set(this, (properties) => __awaiter(this, void 0, void 0, function* () {
            if (properties.accounts && properties.accounts.length > 0) {
                __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_declareWalletAsInstalled).call(this);
                const nextSelectedAccount = yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_accountSelector, "f").call(this, properties.accounts);
                if (nextSelectedAccount !== __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_selectedAccount, "f")) {
                    __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_selectedAccount, nextSelectedAccount, "f");
                    __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_publicKey, undefined, "f");
                    this.emit('connect', 
                    // Having just set `this.#selectedAccount`, `this.publicKey` is definitely non-null
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.publicKey);
                }
            }
        }));
        // this.#chain = chainOrClusterToChainId(config.chain);
        __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_accountSelector, (accounts) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const selectedBase64EncodedAddress = yield config.addressSelector.select(accounts.map(({ publicKey }) => fromUint8Array(publicKey)));
            return (_a = accounts.find(({ publicKey }) => fromUint8Array(publicKey) === selectedBase64EncodedAddress)) !== null && _a !== void 0 ? _a : accounts[0];
        }), "f");
        __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_wallet, wallet, "f");
        __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[StandardEvents].on('change', __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_handleChangeEvent, "f"));
        this.name = __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").name;
        this.icon = __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").icon;
        this.url = __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").url;
        // TODO: evaluate if this logic should be kept - it seems to create a nasty bug where 
        //  the wallet tries to auto connect on page load and gets blocked by the popup blocker
        // if (this.#readyState !== WalletReadyState.Unsupported) {
        //     config.authorizationResultCache.get().then((authorizationResult) => {
        //         if (authorizationResult) {
        //             // Having a prior authorization result is, right now, the best
        //             // indication that a mobile wallet is installed. There is no API
        //             // we can use to test for whether the association URI is supported.
        //             this.#declareWalletAsInstalled();
        //         }
        //     });
        // }
    }
    get publicKey() {
        var _a;
        if (!__classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_publicKey, "f") && __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_selectedAccount, "f")) {
            try {
                __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_publicKey, new web3_js.PublicKey(__classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_selectedAccount, "f").publicKey), "f");
            }
            catch (e) {
                throw new walletAdapterBase.WalletPublicKeyError((e instanceof Error && (e === null || e === void 0 ? void 0 : e.message)) || 'Unknown error', e);
            }
        }
        return (_a = __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_publicKey, "f")) !== null && _a !== void 0 ? _a : null;
    }
    get connected() {
        return __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").connected;
    }
    get connecting() {
        return __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_connecting, "f");
    }
    get readyState() {
        return __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_readyState, "f");
    }
    /** @deprecated Use `autoConnect()` instead. */
    autoConnect_DO_NOT_USE_OR_YOU_WILL_BE_FIRED() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.autoConnect();
        });
    }
    autoConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_connect).call(this, true);
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_connect).call(this);
        });
    }
    /** @deprecated Use `connect()` or `autoConnect()` instead. */
    performAuthorization(signInPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const cachedAuthorizationResult = yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").cachedAuthorizationResult;
                if (cachedAuthorizationResult) {
                    yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[StandardConnect].connect({ silent: true });
                    return cachedAuthorizationResult;
                }
                if (signInPayload) {
                    yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[walletStandardFeatures.SolanaSignIn].signIn(signInPayload);
                }
                else
                    yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[StandardConnect].connect();
                const authorizationResult = yield yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").cachedAuthorizationResult;
                return authorizationResult;
            }
            catch (e) {
                throw new walletAdapterBase.WalletConnectionError((e instanceof Error && e.message) || 'Unknown error', e);
            }
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            // return await this.#runWithGuard(this.#wallet.features[StandardDisconnect].disconnect);
            return yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_runWithGuard).call(this, () => __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_connecting, false, "f");
                __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_publicKey, undefined, "f");
                __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_selectedAccount, undefined, "f");
                yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[StandardDisconnect].disconnect();
                this.emit('disconnect');
            }));
        });
    }
    signIn(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_runWithGuard).call(this, () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (__classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_readyState, "f") !== walletAdapterBase.WalletReadyState.Installed && __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_readyState, "f") !== walletAdapterBase.WalletReadyState.Loadable) {
                    throw new walletAdapterBase.WalletNotReadyError();
                }
                __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_connecting, true, "f");
                try {
                    const outputs = yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[walletStandardFeatures.SolanaSignIn].signIn(Object.assign(Object.assign({}, input), { domain: (_a = input === null || input === void 0 ? void 0 : input.domain) !== null && _a !== void 0 ? _a : window.location.host }));
                    if (outputs.length > 0) {
                        return outputs[0];
                    }
                    else {
                        throw new Error("Sign in failed, no sign in result returned by wallet");
                    }
                }
                catch (e) {
                    throw new walletAdapterBase.WalletConnectionError((e instanceof Error && e.message) || 'Unknown error', e);
                }
                finally {
                    __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_connecting, false, "f");
                }
            }));
        });
    }
    signMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_runWithGuard).call(this, () => __awaiter(this, void 0, void 0, function* () {
                const account = __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_assertIsAuthorized).call(this);
                try {
                    const outputs = yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[walletStandardFeatures.SolanaSignMessage].signMessage({
                        account, message: message
                    });
                    return outputs[0].signature;
                }
                catch (error) {
                    throw new walletAdapterBase.WalletSignMessageError(error === null || error === void 0 ? void 0 : error.message, error);
                }
            }));
        });
    }
    sendTransaction(transaction, connection, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_runWithGuard).call(this, () => __awaiter(this, void 0, void 0, function* () {
                const account = __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_assertIsAuthorized).call(this);
                try {
                    function getTargetCommitment() {
                        let targetCommitment;
                        switch (connection.commitment) {
                            case 'confirmed':
                            case 'finalized':
                            case 'processed':
                                targetCommitment = connection.commitment;
                                break;
                            default:
                                targetCommitment = 'finalized';
                        }
                        let targetPreflightCommitment;
                        switch (options === null || options === void 0 ? void 0 : options.preflightCommitment) {
                            case 'confirmed':
                            case 'finalized':
                            case 'processed':
                                targetPreflightCommitment = options.preflightCommitment;
                                break;
                            case undefined:
                                targetPreflightCommitment = targetCommitment;
                                break;
                            default:
                                targetPreflightCommitment = 'finalized';
                        }
                        const preflightCommitmentScore = targetPreflightCommitment === 'finalized'
                            ? 2
                            : targetPreflightCommitment === 'confirmed'
                                ? 1
                                : 0;
                        const targetCommitmentScore = targetCommitment === 'finalized' ? 2 : targetCommitment === 'confirmed' ? 1 : 0;
                        return preflightCommitmentScore < targetCommitmentScore
                            ? targetPreflightCommitment
                            : targetCommitment;
                    }
                    if (walletStandardFeatures.SolanaSignAndSendTransaction in __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features) {
                        const chain = chainOrClusterToChainId(__classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").currentAuthorization.chain);
                        const [signature] = (yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[walletStandardFeatures.SolanaSignAndSendTransaction].signAndSendTransaction({
                            account,
                            transaction: transaction.serialize(),
                            chain: chain,
                            options: options ? {
                                skipPreflight: options.skipPreflight,
                                maxRetries: options.maxRetries
                            } : undefined
                        })).map(((output) => {
                            return fromUint8Array(output.signature);
                        }));
                        return signature;
                    }
                    else {
                        const [signedTransaction] = yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_performSignTransactions).call(this, [transaction]);
                        if (isVersionedTransaction(signedTransaction)) {
                            return yield connection.sendTransaction(signedTransaction);
                        }
                        else {
                            const serializedTransaction = signedTransaction.serialize();
                            return yield connection.sendRawTransaction(serializedTransaction, Object.assign(Object.assign({}, options), { preflightCommitment: getTargetCommitment() }));
                        }
                    }
                }
                catch (error) {
                    throw new walletAdapterBase.WalletSendTransactionError(error === null || error === void 0 ? void 0 : error.message, error);
                }
            }));
        });
    }
    signTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_runWithGuard).call(this, () => __awaiter(this, void 0, void 0, function* () {
                const [signedTransaction] = yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_performSignTransactions).call(this, [transaction]);
                return signedTransaction;
            }));
        });
    }
    signAllTransactions(transactions) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_runWithGuard).call(this, () => __awaiter(this, void 0, void 0, function* () {
                const signedTransactions = yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_performSignTransactions).call(this, transactions);
                return signedTransactions;
            }));
        });
    }
}
_BaseSolanaMobileWalletAdapter_wallet = new WeakMap(), _BaseSolanaMobileWalletAdapter_connecting = new WeakMap(), _BaseSolanaMobileWalletAdapter_readyState = new WeakMap(), _BaseSolanaMobileWalletAdapter_accountSelector = new WeakMap(), _BaseSolanaMobileWalletAdapter_selectedAccount = new WeakMap(), _BaseSolanaMobileWalletAdapter_publicKey = new WeakMap(), _BaseSolanaMobileWalletAdapter_handleChangeEvent = new WeakMap(), _BaseSolanaMobileWalletAdapter_instances = new WeakSet(), _BaseSolanaMobileWalletAdapter_connect = function _BaseSolanaMobileWalletAdapter_connect(autoConnect = false) {
    return __awaiter(this, void 0, void 0, function* () {
        if (this.connecting || this.connected) {
            return;
        }
        return yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_runWithGuard).call(this, () => __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_readyState, "f") !== walletAdapterBase.WalletReadyState.Installed && __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_readyState, "f") !== walletAdapterBase.WalletReadyState.Loadable) {
                throw new walletAdapterBase.WalletNotReadyError();
            }
            __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_connecting, true, "f");
            try {
                yield __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[StandardConnect].connect({ silent: autoConnect });
            }
            catch (e) {
                throw new walletAdapterBase.WalletConnectionError((e instanceof Error && e.message) || 'Unknown error', e);
            }
            finally {
                __classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_connecting, false, "f");
            }
        }));
    });
}, _BaseSolanaMobileWalletAdapter_declareWalletAsInstalled = function _BaseSolanaMobileWalletAdapter_declareWalletAsInstalled() {
    if (__classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_readyState, "f") !== walletAdapterBase.WalletReadyState.Installed) {
        this.emit('readyStateChange', (__classPrivateFieldSet(this, _BaseSolanaMobileWalletAdapter_readyState, walletAdapterBase.WalletReadyState.Installed, "f")));
    }
}, _BaseSolanaMobileWalletAdapter_assertIsAuthorized = function _BaseSolanaMobileWalletAdapter_assertIsAuthorized() {
    if (!__classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").isAuthorized || !__classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_selectedAccount, "f"))
        throw new walletAdapterBase.WalletNotConnectedError();
    return __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_selectedAccount, "f");
}, _BaseSolanaMobileWalletAdapter_performSignTransactions = function _BaseSolanaMobileWalletAdapter_performSignTransactions(transactions) {
    return __awaiter(this, void 0, void 0, function* () {
        const account = __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_instances, "m", _BaseSolanaMobileWalletAdapter_assertIsAuthorized).call(this);
        try {
            if (walletStandardFeatures.SolanaSignTransaction in __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features) {
                return __classPrivateFieldGet(this, _BaseSolanaMobileWalletAdapter_wallet, "f").features[walletStandardFeatures.SolanaSignTransaction].signTransaction(...transactions.map((value) => {
                    return { account, transaction: value.serialize() };
                })).then((outputs) => {
                    return outputs.map((output) => {
                        const byteArray = output.signedTransaction;
                        const numSignatures = byteArray[0];
                        const messageOffset = numSignatures * SIGNATURE_LENGTH_IN_BYTES + 1;
                        const version = web3_js.VersionedMessage.deserializeMessageVersion(byteArray.slice(messageOffset, byteArray.length));
                        if (version === 'legacy') {
                            return web3_js.Transaction.from(byteArray);
                        }
                        else {
                            return web3_js.VersionedTransaction.deserialize(byteArray);
                        }
                    });
                });
            }
            else {
                throw new Error('Connected wallet does not support signing transactions');
            }
        }
        catch (error) {
            throw new walletAdapterBase.WalletSignTransactionError(error === null || error === void 0 ? void 0 : error.message, error);
        }
    });
}, _BaseSolanaMobileWalletAdapter_runWithGuard = function _BaseSolanaMobileWalletAdapter_runWithGuard(callback) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield callback();
        }
        catch (e) {
            this.emit('error', e);
            throw e;
        }
    });
};
class LocalSolanaMobileWalletAdapter extends BaseSolanaMobileWalletAdapter {
    constructor(config) {
        var _a;
        const chain = chainOrClusterToChainId((_a = config.chain) !== null && _a !== void 0 ? _a : config.cluster);
        super(new walletStandardMobile.LocalSolanaMobileWalletAdapterWallet({
            appIdentity: config.appIdentity,
            authorizationCache: {
                set: config.authorizationResultCache.set,
                get: () => __awaiter(this, void 0, void 0, function* () {
                    const authorizationResult = yield config.authorizationResultCache.get();
                    if (authorizationResult && 'chain' in authorizationResult) {
                        return authorizationResult;
                    }
                    else if (authorizationResult) {
                        return Object.assign(Object.assign({}, authorizationResult), { chain: chain });
                    }
                    else
                        return undefined;
                }),
                clear: config.authorizationResultCache.clear,
            },
            chains: [chain],
            chainSelector: walletStandardMobile.createDefaultChainSelector(),
            onWalletNotFound: () => __awaiter(this, void 0, void 0, function* () {
                config.onWalletNotFound(this);
            }),
        }), {
            addressSelector: config.addressSelector,
            chain: chain,
        });
    }
}
class RemoteSolanaMobileWalletAdapter extends BaseSolanaMobileWalletAdapter {
    constructor(config) {
        const chain = chainOrClusterToChainId(config.chain);
        super(new walletStandardMobile.RemoteSolanaMobileWalletAdapterWallet({
            appIdentity: config.appIdentity,
            authorizationCache: {
                set: config.authorizationResultCache.set,
                get: () => __awaiter(this, void 0, void 0, function* () {
                    const authorizationResult = yield config.authorizationResultCache.get();
                    if (authorizationResult && 'chain' in authorizationResult) {
                        return authorizationResult;
                    }
                    else if (authorizationResult) {
                        return Object.assign(Object.assign({}, authorizationResult), { chain: chain });
                    }
                    else
                        return undefined;
                }),
                clear: config.authorizationResultCache.clear,
            },
            chains: [chain],
            chainSelector: walletStandardMobile.createDefaultChainSelector(),
            remoteHostAuthority: config.remoteHostAuthority,
            onWalletNotFound: () => __awaiter(this, void 0, void 0, function* () {
                config.onWalletNotFound(this);
            }),
        }), {
            addressSelector: config.addressSelector,
            chain: chain,
        });
    }
}
class SolanaMobileWalletAdapter extends LocalSolanaMobileWalletAdapter {
}

function createDefaultAddressSelector() {
    return {
        select(addresses) {
            return __awaiter(this, void 0, void 0, function* () {
                return addresses[0];
            });
        },
    };
}

function createDefaultAuthorizationResultCache() {
    return walletStandardMobile.createDefaultAuthorizationCache();
}

function defaultWalletNotFoundHandler(mobileWalletAdapter) {
    return __awaiter(this, void 0, void 0, function* () {
        return walletStandardMobile.defaultErrorModalWalletNotFoundHandler();
    });
}
function createDefaultWalletNotFoundHandler() {
    return defaultWalletNotFoundHandler;
}

exports.LocalSolanaMobileWalletAdapter = LocalSolanaMobileWalletAdapter;
exports.RemoteSolanaMobileWalletAdapter = RemoteSolanaMobileWalletAdapter;
exports.SolanaMobileWalletAdapter = SolanaMobileWalletAdapter;
exports.SolanaMobileWalletAdapterWalletName = SolanaMobileWalletAdapterWalletName;
exports.createDefaultAddressSelector = createDefaultAddressSelector;
exports.createDefaultAuthorizationResultCache = createDefaultAuthorizationResultCache;
exports.createDefaultWalletNotFoundHandler = createDefaultWalletNotFoundHandler;
